// Format the output with the correct number of commas before the word "and"
export const pluralizeList = items => {
  if (!Array.isArray(items) || items.length === 0) {
    return ""
  }

  if (items.length === 1) {
    return items[0]
  }

  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`
  }

  // For 3 or more items: "a, b, c, and d"
  const allButLast = items.slice(0, -1)
  const last = items[items.length - 1]

  return `${allButLast.join(", ")}, and ${last}`
}
